import {create} from 'zustand'
import {createJSONStorage, persist} from 'zustand/middleware'
import type {DevUser} from '@/lib/api/dev'

type ImpersonationStore = {
	target: DevUser | null
	setTarget: (user: DevUser | null) => void
}

export const useImpersonationStore = create<ImpersonationStore>()(
	persist(
		(set) => ({
			target: null,
			setTarget: (user) => set({target: user}),
		}),
		{
			name: 'dev-impersonation',
			storage: createJSONStorage(() => sessionStorage),
		},
	),
)

export function getImpersonationTarget(): DevUser | null {
	return useImpersonationStore.getState().target
}
